import React, { useEffect, useState } from 'react';
import { Copy, Check } from 'lucide-react';

/**
 * One or more copyable Stripe promotion-code chips for the promo banner.
 * Shared by PromoBanner (live) and PromoBannerEditor (preview).
 */
export default function PromoCouponChips({ codes, chipClassName, interactive = true }) {
  const [copiedCode, setCopiedCode] = useState(null);
  const list = Array.isArray(codes) ? codes.filter(Boolean) : [];

  useEffect(() => {
    if (!copiedCode) return undefined;
    const t = setTimeout(() => setCopiedCode(null), 1500);
    return () => clearTimeout(t);
  }, [copiedCode]);

  if (list.length === 0) return null;

  const handleCopy = async (code) => {
    if (!interactive || !code) return;
    try {
      await navigator.clipboard.writeText(code);
      setCopiedCode(code);
    } catch {
      // Clipboard blocked — code remains visible for manual copy.
    }
  };

  return (
    <>
      {list.map((code) => {
        const copied = copiedCode === code;
        const className = `inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] sm:text-xs font-mono uppercase tracking-wide transition-colors ${chipClassName || ''}`;
        if (!interactive) {
          return (
            <span key={code} className={className}>
              <Copy size={12} /> {code}
            </span>
          );
        }
        return (
          <button
            key={code}
            type="button"
            onClick={() => handleCopy(code)}
            className={className}
            title={copied ? 'Copied!' : 'Click to copy'}
          >
            {copied ? <Check size={12} /> : <Copy size={12} />}
            {code}
          </button>
        );
      })}
    </>
  );
}
